// Module
var code = "<h2 id=\"interest-savings-calculator\">Interest Savings Calculator</h2> <p>If you have an unsubsidized loan, see how much you could save if you pay the interest on your loan while you are in school.</p> ";
// Exports
export default code;